import * as angular from "angular";
import {IController} from "angular";

export class planningActivityPackagesInfoCtrl implements IController {
  packages: any;
  isPacked: any;
}

angular
  .module('bringoz.admin.planning')
  .component('planningActivityPackagesInfo', {
    bindings: {
      packages: '<',
      isPacked: '<'
    },
    template: require('./planning-activity-packages-info.html').default,
    controller: planningActivityPackagesInfoCtrl
  });
